export enum HealthCentersRoutesEnum {
  LIST= '',
  CREATE = 'create',
  EDIT = 'edit/:healthCenterId',
  VIEW = 'view/:healthCenterId',
}
